module.exports = __webpack_public_path__ + "static/famr.us_certifications-4c5859d7e38342d352ef6022a8473ec9.jpg";